// extracted by mini-css-extract-plugin
export default {"badge":"LadderFixedAcosBadge_badge__RGUPW","stale":"LadderFixedAcosBadge_stale__eUnn8"};